/*
 * Copyright (c) 2025 Ping Identity Corporation. All rights reserved.
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { createSlice } from '@reduxjs/toolkit';
import { convertWellknown } from './wellknown.utils.js';
const initialState = {
    serverConfig: { baseUrl: '', paths: { authenticate: '', sessions: '' } },
};
/**
 * Redux slice for journey client configuration.
 *
 * Separated from the journey auth state slice (which holds authId, step, error)
 * so that configuration concerns don't mix with authentication flow state.
 * The `set` action converts the raw well-known response via `convertWellknown()`
 * and stores the resulting `ResolvedServerConfig`.
 */
export const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        set(state, action) {
            const wellknown = convertWellknown(action.payload.wellknownResponse);
            if ('error' in wellknown) {
                state.error = wellknown;
            }
            else {
                state.serverConfig = wellknown;
                state.error = undefined;
            }
        },
    },
});
